export class NewDealReqest {
  campaignDetails: CampaignDetails;
  customerIds: number[];
  productIds: number[];
}

export class CampaignDetails {
  name: string;

  constructor(name = "") {
    this.name = name;
  }
}
